import React from "react";
import styled from "styled-components";
import { Colors } from "../../ColorConstants";
import { TickCircle } from "../../assets/icons";

const PlaceholderDiscountText = ({discountDetails}) => {

  return (
    <MainContainer>
      <LeftImageContainer>
        <TickCircleImage src={TickCircle}/>
      </LeftImageContainer>
      <RightContainer>
        <UpperText>{discountDetails?.discountPercentage}% Discount <span>applied</span></UpperText>
        <LowerText>-QAR {discountDetails?.discountAmount} ({discountDetails?.discountPercentage}%off)</LowerText>
      </RightContainer>
    </MainContainer>
  );
};

export default PlaceholderDiscountText;

const MainContainer = styled.div`
  display: flex;
  // padding: 1rem;
  box-sizing: border-box;
  // justify-content: center;
  gap: 1.5rem;
  align-items: center;
  width: 75%;
  height: 100%;
  border-radius: 12px 0px 0px 12px;
  border: 0.5px solid ${Colors.rainbowGrey};
  box-sizing: border-box;
  outline: none;
  padding: 0.5rem 0rem 0.5rem 0.5rem;
  @media only screen and (max-width: 375px) {
    gap: 0.5rem;
  }
`;

const LeftImageContainer = styled.div`
  display: flex;
  //   flex-direction: column;
  justify-content: center;
`;
const TickCircleImage = styled.img`
  width: 2rem;
  height: 2rem;
  resize-mode: contain;
`;

const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  height: 100%;
`;
const UpperText = styled.span`
  color: ${Colors.black}
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 500;
  >span {
    font-weight: 400;
    font-size: 0.7rem;
  }
`;
const LowerText = styled.span`
  color: var(--Dark-Grey, #666);
  font-size: 9px;
  font-style: normal;
  font-weight: 400;
`;
